module.exports = __webpack_public_path__ + "img/image5.fe81dbb2.jpeg";